export default [
  {
    path: '/main/arena/user',
    meta: {
      tag: 'list_arena_user',
      name: 'Usuário (Arena)',
      breadcrumb: 'Usuário (Arena)'
    },
    component: () => import(/* webpackChunkName: "arena-user-list" */ '@/views/main/settings/arena/user/Index.vue'),
    children: [
      {
        path: '',
        name: 'listarenauser',
        meta: {
          tag: 'list_arena_user',
          menu: 'settings',
          name: 'Usuário (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-user-list" */ '@/views/main/settings/arena/user/List.vue'),
      },
      {
        path: '/main/arena/user/add',
        name: 'addarenauser',
        meta: {
          tag: 'add_arena_user',
          menu: 'settings',
          name: 'Adicionar | Usuário (Arena)',
          breadcrumb: 'Adicionar Usuário (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-user-add" */ '@/views/main/settings/arena/user/Add.vue')
      },
      {
        path: '/main/arena/user/:id',
        name: 'editarenauser',
        meta: {
          tag: 'edit_arena_user',
          menu: 'settings',
          name: 'Editar | Usuário (Arena)',
          breadcrumb: 'Editar Usuário (Arena)'
        },
        component: () => import(/* webpackChunkName: "arena-user-edit" */ '@/views/main/settings/arena/user/Edit.vue')
      }
    ]
  }
]
